interface IProps {
  title: string;
  header: string;
}

export const TitleHeader = ({ title, header }: IProps) => {
  return (
    <div className={`flex flex-col gap-2 md:gap-4`}>
      <h1
        className={
          "text-xl md:text-4xl font-medium text-pretty text-primary-600"
        }
      >
        {title}
      </h1>
      <h2 className={"text-md md:text-3xl text-pretty text-primary-400"}>
        {header}
      </h2>
    </div>
  );
};
